import { token } from '@atlaskit/tokens';

export const itemLinkSecondaryColor: 'var(--ds-text-subtlest)' = token('color.text.subtlest');
